// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__bdcys","skipLink":"Layout_skipLink__hyGGe","main":"Layout_main__dX7Pd"};